<script lang="ts">
    import SvgIcon from "$lib/components/assets/SvgIcon.svelte";
    import type {LoggedIn} from '$lib/classes/stores/logged-in';

    export let buttonType: 'known' | 'learn'
    export let loggedIn: LoggedIn
    export let status: string

    let hovered = false
</script>

<!-- TODO make button -->
<!-- TODO use Status for buttonType and status ?? -->
<!-- svelte-ignore a11y-click-events-have-key-events  a11y-no-static-element-interactions -->
<div class="list-btn list-btn-{buttonType}"
     data-testid="{buttonType === 'known' ? 'save-as-known' : 'save-to-learn'}-btn"
     class:logged-in={$loggedIn}
     class:logged-out={!$loggedIn}
     style:color={status === buttonType.toUpperCase() ? 'var(--text-on-color)' : 'var(--color-accent)'}
     style:background={status === buttonType.toUpperCase() ? `var(--color-accent)` : ''}
     on:click|stopPropagation
     on:mouseenter={() => hovered = true}
     on:mouseleave={() => hovered = false}
>
    {buttonType === 'known' ? '✓' : '•'}
    {#if hovered}
        {#if buttonType === 'known'}
            <div class="list-tooltip">
                <SvgIcon name="known" width="32px" height="32px"
                         viewBox="0 0 32 32"
                         fill="var(--text-on-color)"
                />
                Super easy?<br>
                Mark as <b>'known'</b>
            </div>
        {:else}
            <div class="list-tooltip">
                <SvgIcon name="learn" width="32px" height="32px"
                         viewBox="0 0 32 32"
                         fill="var(--text-on-color)"
                />&nbsp;
                <b>Learn</b><br>this word
            </div>
        {/if}
    {/if}
</div>

<!--suppress CssUnusedSymbol -->
<style>
    .list-btn {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1.3rem;
        height: 1.3rem;
        margin: 0 0 0 auto;
        padding: 0;
        font-size: 1.1rem;
        color: var(--color-accent);
        background: var(--color-light);
        font-weight: var(--font-bold);
        border-radius: 3px;
        border: 1px solid transparent;
        transition: var(--transition);
    }

    .list-btn:last-child {
        line-height: 1rem;
    }

    .list-btn:hover {
        border: 1px solid var(--color-accent);
        box-shadow: 0 0 0 1px var(--color-accent);
    }

    .list-tooltip {
        display: none;
    }

    .list-btn.logged-out:hover .list-tooltip {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        background-color: var(--color-accent);
        color: white;
        padding: .5rem .6rem;
        font-size: .9rem;
        font-weight: normal;
        text-align: center;
        white-space: nowrap;
        box-shadow: var(--shadow);
        border-radius: 3px;
        z-index: 5;
        /*pointer-events: none;*/
    }

    .list-btn-known.logged-in:hover::before {
        background-image: url("/Linecons_bulb.svg");
    }

    .list-btn-learn.logged-in:hover::before {
        background-image: url("/Linecons_study.svg");
    }

    .list-btn-known.logged-in:hover::before,
    .list-btn-learn.logged-in:hover::before {
        content: '';
        width: 1.8rem;
        height: 1.8rem;
        background-size: 75%;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-position: center;
    }

    .frequency:hover::before,
    .level:hover::before,
    .list-btn-known.logged-in:hover::before,
    .list-btn-learn.logged-in:hover::before {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, calc(-100% - 5px));
        background-color: var(--color-accent);
        color: white;
        padding: .4rem;
        border-radius: 3px;
        box-shadow: var(--shadow);
        font-weight: bold;
        pointer-events: none;
    }

    .list-btn-known:hover .list-tooltip {
        transform: translate(2rem, calc(-100% - 7px));
    }

    .list-btn-learn:hover .list-tooltip {
        transform: translate(.4rem, calc(-100% - 7px));
        text-align: right;
    }
</style>